module.exports = __webpack_public_path__ + "img/ai-img-mouse.709e46a7.png";